import { render, staticRenderFns } from "./adsList.vue?vue&type=template&id=678451e2&scoped=true&"
import script from "./adsList.vue?vue&type=script&lang=js&"
export * from "./adsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678451e2",
  null
  
)

export default component.exports